import { render, staticRenderFns } from "./ZChip.vue?vue&type=template&id=397754fe&"
import script from "./ZChip.vue?vue&type=script&lang=js&"
export * from "./ZChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports